import { render } from "./TurboStake.vue?vue&type=template&id=2a45b6a7"
import script from "./TurboStake.vue?vue&type=script&lang=js"
export * from "./TurboStake.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TurboStake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a45b6a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a45b6a7', __exports__)) {
    api.reload('2a45b6a7', __exports__)
  }
  
  module.hot.accept("./TurboStake.vue?vue&type=template&id=2a45b6a7", () => {
    api.rerender('2a45b6a7', render)
  })

}


export default __exports__